import { App } from "vue";
import { type ArticleFilters, useArticleFilters } from "@/composables/filters/article-filters";
import { type CategoryFilter, useCategoryFilter } from "@/composables/filters/category-filter";
import { type ProductFilter, useProductFilter } from "@/composables/filters/product-filter";
import { type TradeAlertFilters, useTradeAlertFilters } from "@/composables/filters/trade-alert-filters";
import { type BonusReportFilters, useBonusReportFilters } from "@/composables/filters/bonus-report-filters";
import { type WebinarFilters, useWebinarFilters } from "@/composables/filters/webinar-filters";
import { type PagingFilter, usePagingFilter } from "@/composables/filters/paging-filter";

export const articleFiltersSymbol = Symbol( 'article-filters' );
export const bonusReportFiltersSymbol = Symbol( 'bonus-report-filters' );
export const tradeAlertFiltersSymbol = Symbol( 'trade-alert-filters' );
export const webinarFiltersSymbol = Symbol( 'webinar-filters' );

export const categoryFilterSymbol = Symbol( 'category-filter' );
export const pagingFilterSymbol = Symbol( 'paging-filter' );
export const productFilterSymbol = Symbol( 'product-filter' );

const ContentFiltersPlugin = {
    install( app: App< Element > ) {
        // Register the Category Filter provider
        app.provide< CategoryFilter >( categoryFilterSymbol, useCategoryFilter() );
        // Register the Paging Filter provider
        app.provide< PagingFilter >( pagingFilterSymbol, usePagingFilter() );
        // Register the Product Filter provider
        app.provide< ProductFilter >( productFilterSymbol, useProductFilter() );

        // Register the Article Filter provider
        app.provide< ArticleFilters >( articleFiltersSymbol, useArticleFilters() );
        // Register the Bonus Report Filter provider
        app.provide< BonusReportFilters >( bonusReportFiltersSymbol, useBonusReportFilters() );
        // Register the Trade Alert Filter provider
        app.provide< TradeAlertFilters >( tradeAlertFiltersSymbol, useTradeAlertFilters() );
        // Register the Webinar Filter provider
        app.provide< WebinarFilters >( webinarFiltersSymbol, useWebinarFilters() );
    }
}

export default ContentFiltersPlugin;
